import type { Step } from "react-joyride";

export const serviceStandardMappingTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າການຜູກມາດຕະຖານບໍລິການ! ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການການຜູກມາດຕະຖານບໍລິການກັບຕໍາແໜ່ງ, Checklist, ມາດຕະຖານ QC ແລະ KPI. ການຜູກມັດນີ້ຈະຊ່ວຍໃຫ້ສາມາດຈັດການການບໍລິການກັບ Checklist ແລະນຳຜົນການບໍລິການໄປໃຊ້ໃນການຄິດໄລ່ KPI ໄດ້. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="mapping-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງການຜູກມັດໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງການຜູກມັດມາດຕະຖານບໍລິການກັບຕໍາແໜ່ງ, Checklist, ມາດຕະຖານ QC ຫຼື KPI.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="mapping-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາການຜູກມັດຕາມມາດຕະຖານບໍລິການ, ຕໍາແໜ່ງ, Checklist, ມາດຕະຖານ QC, ຫຼື KPI. ກົດປຸ່ມລຶບເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="mapping-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງການຜູກມັດທັງໝົດ. ທ່ານຈະເຫັນມາດຕະຖານບໍລິການ, ຕໍາແໜ່ງ, Checklist, ມາດຕະຖານ QC, ແລະ KPI ທີ່ຜູກມັດກັນ. ທ່ານສາມາດແກ້ໄຂຫຼືລຶບການຜູກມັດໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະການຜູກມັດ.",
    placement: "top",
  },
];
